import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48827b1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" SchedulX"),
          _hoisted_3,
          _createTextVNode(" 云原生智能运维平台 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString('SchedulX是一款具备先进Serverless和FinOps能力的智能运维平台，' +
          '帮助基于任意语言开发的Web系统在零代码改造的前提下实现Serverless化，' +
          '通过全自动化部署发布、性能维护、稳定性治理，减少90%以上的运维工作，整体IT成本节省可达60%以上。'))
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$RQ.GoGSS()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 免费体验 ")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$Store.Page().openModal('modalFormCollection','demo')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 预约咨询 ")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ]))
}